import "@bcc-ui/ui-components/style.css";
import { FlagsProvider } from "flagged";
import React from "react";
import { createRoot } from "react-dom/client";
import ReactModal from "react-modal";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";

import BlanccoCommonCloud from "components/BlanccoCommonCloud";
import { featureFlagService } from "services/feature/FeatureFlagService";
import { store } from "store";

const APP_ELEMENT_ID = "blancco-common-cloud";
const container = document.getElementById(APP_ELEMENT_ID) as HTMLElement;
const queryClient = new QueryClient();

const root = createRoot(container);

ReactModal.setAppElement(container);

root.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <FlagsProvider features={featureFlagService.getFlags()}>
                <BlanccoCommonCloud />
            </FlagsProvider>
        </QueryClientProvider>
    </Provider>
);
